





































































import Vue, { PropType } from 'vue';
import * as tools from '@/modules/tools';
import { v4 } from 'uuid';
// import { ItemData } from '@/modules/exhibitor/item';
// import { Option, options } from 'mostra';
import {
  Option,
  options,
  Item,
  item,
  Sku,
} from 'mostra';
// import { Option, skuTypes } from '@/modules/options';
export type SkusType = {
  sku: Sku;
  key: string;
}

export type DataType = {
  skuTypes: Option;
  skuDisabledTypes: Option;
  // isChange: boolean;
  // isSkuColumn: boolean;
};

export default Vue.extend({
  name: 'GItemSkuForm',
  props: {
    item: {
      type: Object as PropType<Item>,
      required: true,
    },
  },
  data(): DataType {
    return {
      skuTypes: options.skuTypes,
      skuDisabledTypes: options.skuDisabledTypes,
      // isChange: false,
      // isSkuColumn: false,
    };
  },
  computed: {
    skus(): SkusType[] {
      return this.item.data.sku.skus.map((sku) => ({
        sku,
        key: v4(),
      }));
    },
  },
  methods: {
    addNewSku() {
      const newSku = item.createNewSku(this.item.data.base.isPriceUndecided);
      newSku.price = this.item.data.base.price;
      newSku.number = this.item.data.base.itemNumber;
      if (this.item !== null) this.item.data.sku.skus.push(newSku);
    },
    onDeleteSku(list: string[], index: number) {
      tools.deleteList(list, index);
      // await this.onDelete(list, index);
    },
    onUpSku(list: string[], index: number) {
      // await this.onUp(list, index);
      tools.upList(list, index);
    },
    async onDownSku(list: string[], index: number) {
      tools.downList(list, index);
      // await this.onDown(list, index);
    },
    // handleResize() {
    //   if (!this.$refs.skuContents) return;
    //   const skuContentsWidth = this.$refs.skuContents[0].clientWidth;
    //   this.isSkuColumn = skuContentsWidth < 790;
    // },
  },
  // mounted() {
  //   window.addEventListener('resize', this.handleResize);
  // },
  // beforeDestroy() {
  //   window.removeEventListener('resize', this.handleResize);
  // },
});
